import { render, staticRenderFns } from "./IOS-Dark.vue?vue&type=template&id=8abc75ca"
import script from "./IOS-Dark.vue?vue&type=script&lang=js"
export * from "./IOS-Dark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports